import eventQueue from '../queue';
import { EventAction, EventType } from '../../types/events';
import isGuidedSwitch from '../../LinkApiRouter/utils/guided-switch';
function attachEventListeners() {
    eventQueue.on('link_api_action', function (_a) {
        var action = _a.action, fireAnalyticsEvent = _a.fireAnalyticsEvent, state = _a.state;
        var linkApi = state.linkApi, linkParams = state.linkParams;
        var platform = linkApi.context.platform;
        var isGuidedSwitchAction = isGuidedSwitch(platform, linkParams.featureFlags);
        if (action.actionType === 'payload' &&
            isGuidedSwitchAction &&
            action.label.toLowerCase() === 'skip') {
            fireAnalyticsEvent(EventAction.TAP_SKIP, { platform_id: platform.id }, EventType.LINK_GUIDED_SWITCH_EVENT);
        }
    });
}
attachEventListeners();
